import { render, staticRenderFns } from "./ruleMng.vue?vue&type=template&id=51c9e5d2&scoped=true"
import script from "./ruleMng.vue?vue&type=script&lang=js"
export * from "./ruleMng.vue?vue&type=script&lang=js"
import style0 from "./ruleMng.vue?vue&type=style&index=0&id=51c9e5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c9e5d2",
  null
  
)

export default component.exports